import React from 'react';

/**
 * SettingsCarriers - Carrier management tab component
 * Contains: carrier list table, search, edit/delete functionality
 */
const SettingsCarriers = ({
  carriers,
  carrierSearch,
  onCarrierSearchChange,
  onEditCarrier,
  onDeleteCarrier
}) => {
  const filteredCarriers = carriers.filter(c =>
    c.name?.toLowerCase().includes(carrierSearch.toLowerCase())
  );

  return (
    <div className="settings-section">
      <div className="section-header">
        <div className="section-header-left">
          <h2>Carriers</h2>
          <span className="item-count">{filteredCarriers.length} carriers</span>
        </div>
      </div>

      <div className="section-controls">
        <div className="search-container">
          <div className="search-box">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="M21 21l-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search carriers..."
              value={carrierSearch}
              onChange={(e) => onCarrierSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>

      {filteredCarriers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🚚</div>
          <p className="empty-text">No carriers found</p>
          <p className="empty-subtext">
            {carrierSearch ? 'Try a different search term' : 'Add carriers to get started'}
          </p>
        </div>
      ) : (
        <div className="users-table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>Carrier Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredCarriers.map((c) => (
                <tr key={c.id}>
                  <td className="username">{c.name}</td>
                  <td className="actions-cell">
                    <button className="action-btn edit" onClick={() => onEditCarrier(c)}>
                      Edit
                    </button>
                    <button className="action-btn delete" onClick={() => onDeleteCarrier(c.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SettingsCarriers;
